import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

/* ----------------------------- Link Config ----------------------------- */
const links = [
  // { to: "/dashboard", label: "Dashboard", icon: "grid" },
  { to: "/sales", label: "Shop Package Sales", icon: "calendar" },
  { to: "/shop-owners-summary", label: "Shop Owners Summary", icon: "chart" },
  { to: "/referral-users", label: "Sales Agents", icon: "users" },
  { to: "/package-orders", label: "Shop Package Orders", icon: "checklist" },
  { to: "/instructor-users", label: "Shop Registration", icon: "teacher" },
  { to: "/instructor-packages", label: "Shop Packages", icon: "tag" },
  // { to: "/orders-review", label: "Course Orders Review", icon: "checklist" },
  // { to: "/product-order-review", label: "Product Orders Review", icon: "box" },
  // { to: "/services-review", label: "Services Review", icon: "insight" },
  // { to: "/buyer-insights", label: "Buyer Insights", icon: "insight" },
  { to: "/store-sponsorships", label: "Store Sponsorships", icon: "sparkle" },
  { to: "/storefront-templates", label: "Storefront Templates", icon: "box" },
  { to: "/virtual-mall-settings", label: "3D Mall Settings", icon: "box" },
  {
    to: "/affiliate-settlements",
    label: "Affiliate Settlements",
    icon: "users",
  },

  { to: "/admin-referral-codes", label: "Level 1 Codes", icon: "tag" },

  { to: "/add-admin", label: "Add New Admin", icon: "shield" },

  { to: "/banks-settings", label: "Banks Settings", icon: "insight" },

  { to: "/listing-categories", label: "Listing Categories", icon: "tag" },
];

/* ----------------------------- Icons (inline SVG, no libs) ----------------------------- */
function Icon({ name, className = "w-5 h-5" }) {
  const props = {
    className,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
  };
  switch (name) {
    case "grid":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="3" width="8" height="8" rx="2" />
          <rect x="13" y="3" width="8" height="8" rx="2" />
          <rect x="3" y="13" width="8" height="8" rx="2" />
          <rect x="13" y="13" width="8" height="8" rx="2" />
        </svg>
      );
    case "calendar":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="5" width="18" height="16" rx="2" />
          <path d="M16 3v4M8 3v4M3 11h18" />
        </svg>
      );
    case "chart":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M3 3v18h18" />
          <path d="M7 15l4-4 3 3 5-6" />
          <circle cx="7" cy="15" r="1.6" />
          <circle cx="11" cy="11" r="1.6" />
          <circle cx="14" cy="14" r="1.6" />
          <circle cx="19" cy="8" r="1.6" />
        </svg>
      );
    case "tag":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M20 13l-7 7-10-10V3h7z" />
          <circle cx="7.5" cy="7.5" r="1.5" />
        </svg>
      );
    case "users":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "teacher":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="7" r="3.2" />
          <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
          <path d="M3 10l9-5 9 5-9 5-9-5z" />
        </svg>
      );
    case "shield":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M12 3l7 4v5c0 5-3.4 8.4-7 9-3.6-.6-7-4-7-9V7z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case "checklist":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M9 6h11M9 12h11M9 18h11" />
          <path d="M4 6l1.5 1.5L8 5" />
          <path d="M4 12l1.5 1.5L8 11" />
          <path d="M4 18l1.5 1.5L8 17" />
        </svg>
      );
    case "box":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M21 16V8a2 2 0 0 0-1-1.73L13 2.27a2 2 0 0 0-2 0L4 6.27A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <path d="M3.3 7.3L12 12l8.7-4.7" />
        </svg>
      );
    case "insight":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M3 12s3-7 9-7 9 7 9 7-3 7-9 7-9-7-9-7z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      );
    case "sparkle":
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z" />
          <path d="M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16z" />
          <path d="M5 15l.8 2.2L8 18l-2.2.8L5 21l-.8-2.2L2 18l2.2-.8L5 15z" />
        </svg>
      );
    default:
      return <div className={className} />;
  }
}

/* ----------------------------- Sidebar ----------------------------- */
const STORAGE_KEY = "admin_sidebar_collapsed";

const Sidebar = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const firstLoad = useRef(true);

  // persist collapse state
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved != null) setCollapsed(saved === "1");
  }, []);
  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  // close on ESC (mobile)
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setMobileOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  // dynamic width
  const widthClass = collapsed ? "w-16" : "w-64";
  const labelVis = collapsed ? "opacity-0 pointer-events-none" : "opacity-100";
  const tooltipIfCollapsed = (txt) => (collapsed ? txt : undefined);

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside
        className={`fixed left-0 top-0 h-screen ${widthClass} z-50
        bg-[#0B1220] text-white shadow-2xl border-r border-white/10
        transition-[width] duration-300 ease-out flex flex-col`}
      >
        {/* Header */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-pink-500/10 pointer-events-none" />
          <div className="h-16 px-3 flex items-center justify-between">
            <div className="flex items-center gap-2 overflow-hidden">
              <div className="w-9 h-9 rounded-xl bg-white/10 grid place-items-center text-lg font-black tracking-tight">
                A
              </div>
              <div
                className={`transition-all duration-300 ${labelVis}`}
                aria-hidden={collapsed}
              >
                <div className="text-sm text-white/60 leading-4">Admin</div>
                <div className="text-lg font-bold tracking-tight">Control</div>
              </div>
            </div>

            {/* Collapse / Mobile toggle */}
            <div className="flex items-center gap-1">
              <button
                className="hidden md:inline-flex p-2 rounded-lg hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/20"
                title={collapsed ? "Expand" : "Collapse"}
                onClick={() => setCollapsed((v) => !v)}
                aria-label="Toggle sidebar"
              >
                {/* chevrons */}
                <svg
                  viewBox="0 0 24 24"
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  {collapsed ? (
                    <path d="M9 18l6-6-6-6" />
                  ) : (
                    <path d="M15 18l-6-6 6-6" />
                  )}
                </svg>
              </button>
              <button
                className="md:hidden inline-flex p-2 rounded-lg hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/20"
                onClick={() => setMobileOpen((v) => !v)}
                aria-label="Toggle sidebar (mobile)"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 6h18M3 12h18M3 18h18" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="mt-2 overflow-y-auto custom-scroll flex-1 py-2">
          <div className="px-2 space-y-1">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                title={tooltipIfCollapsed(link.label)}
                className={({ isActive }) =>
                  [
                    "group flex items-center gap-3 px-2 py-2 rounded-xl transition-colors",
                    "focus:outline-none focus:ring-2 focus:ring-white/20",
                    isActive
                      ? "bg-white/10 text-white"
                      : "text-white/80 hover:bg-white/5 hover:text-white",
                  ].join(" ")
                }
              >
                {({ isActive }) => (
                  <>
                    {/* left active bar */}
                    <span
                      className={[
                        "w-1 self-stretch rounded-full transition-all",
                        isActive
                          ? "bg-gradient-to-b from-indigo-400 to-fuchsia-400"
                          : "bg-transparent",
                        collapsed ? "opacity-0" : "opacity-100",
                      ].join(" ")}
                    />
                    {/* icon */}
                    <span className="shrink-0 grid place-items-center w-9 h-9 rounded-lg bg-white/5 group-hover:bg-white/10">
                      <Icon name={link.icon} />
                    </span>
                    {/* label */}
                    <span
                      className={`truncate transition-all duration-200 ${labelVis}`}
                      aria-hidden={collapsed}
                    >
                      {link.label}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>

        {/* Footer / Logout */}
        <div className="p-3 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="w-full inline-flex items-center justify-center gap-2 px-3 py-2 rounded-xl
                       bg-red-600 hover:bg-red-700 text-white font-semibold shadow focus:outline-none focus:ring-2 focus:ring-red-400/40"
            title="Sign out"
          >
            <svg
              viewBox="0 0 24 24"
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v3" />
              <path d="M10 17l-5-5 5-5" />
              <path d="M21 12H5" />
              <path d="M15 21h4a2 2 0 0 0 2-2v-3" />
            </svg>
            <span
              className={`transition-all ${labelVis}`}
              aria-hidden={collapsed}
            >
              Logout
            </span>
          </button>
        </div>
      </aside>

      {/* Mobile slide-in positioning (push content) */}
      <button
        className="fixed bottom-4 left-4 z-40 md:hidden inline-flex items-center gap-2 px-3 py-2 rounded-xl
                   bg-[#0B1220] text-white shadow-lg border border-white/10"
        onClick={() => setMobileOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          viewBox="0 0 24 24"
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 6h18M3 12h18M3 18h18" />
        </svg>
        <span>Menu</span>
      </button>

      {/* Offset main content */}
      <div className={`hidden md:block`} aria-hidden />
    </>
  );
};

export default Sidebar;

/* --------- Optional: thin custom scrollbar (Tailwind-safe) ---------
Add this to your global CSS (e.g., index.css):
.custom-scroll::-webkit-scrollbar{width:8px}
.custom-scroll::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:8px}
.custom-scroll:hover::-webkit-scrollbar-thumb{background:#ffffff3a}
-------------------------------------------------------------------- */
